import React from 'react';
import { useDispatch } from 'react-redux';
import { NoConnectionIcon, Box } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { EmptyState } from '@epi-shared/components/EmptyState';
import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';

export const IngestroError = () => {
  const reduxDispatch = useDispatch();
  const { t } = useTranslation();
  const { warningColorLight, warningColor } = useTheme();

  return (
    <Box
      bgcolor={warningColorLight}
      border={`1px solid ${warningColor}`}
      borderRadius={1}
      pt={2.5}
      pb={8}
      px={24}
      mt={6}
    >
      <EmptyState
        icon={<NoConnectionIcon />}
        title={t(
          'containers.beneficiaries.import_employees.service_error.title'
        )}
        description={t(
          'containers.beneficiaries.import_employees.service_error.description'
        )}
        btnText={t(
          'containers.beneficiaries.import_employees.service_error.button'
        )}
        btnOnClick={() => reduxDispatch(goToPage(routerPaths.beneficiaries))}
      />
    </Box>
  );
};
